import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { api } from 'src/common/utils/api';
import { useFileUploadMutation } from 'src/data-capture/hooks/useFileUploadMutation';
import { Logger } from 'src/utils/Logger';
import { FundDocument } from '../types';

export const useCreateFundDocument = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { uploadToFileStorage } = useFileUploadMutation();
  const queryClient = useQueryClient();

  const createFundDocument = async (
    fundId: string,
    file: File,
    document: Omit<FundDocument, 'id'>,
  ) => {
    try {
      setIsLoading(true);
      await uploadToFileStorage({ file, subfolder: 'funds' });
      await api.post<FundDocument>(`funds/${fundId}/files`, {
        ...document,
        file: {
          ...document.file,
          subfolder: 'funds',
        },
      });
      queryClient.invalidateQueries({ queryKey: ['funds', fundId, 'files'] });
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      Logger.error('Failed to upload fund file', e);
      throw e;
    }
  };

  return {
    createFundDocument,
    isLoading,
  };
};
